import {Component} from '@wonderlandengine/api';
import {WLUtils} from '../../utils/WLUtils.js';
import {UnlockManager} from '../../components/unlock-manager.js';
import {GameFlowController} from '../../components/game-flow-controller.js';
import {MissionManager} from '../../components/mission-manager.js';

export class MalwearEquipHotkey {
    //private MalWearManager.MalWearNames wearName;
    //private MalWearManager malWearManager;

    setup(wearName: any) {}
    onClick() {
        //malWearManager = MalWearManager.GetInstance();
        //  malWearManager.PlayChangeAnimation(wearName);
        if (UnlockManager.instance.notificationVisible) {
            UnlockManager.instance.acknowledgedNotification();
        } else if (GameFlowController.instance.rewardsActive()) {
            //MissionManager.instance.createNewMissions();
            //GameFlowController.instance.closeRewards();
        }
    }
}
